// TODO: Use what possible from `@hugerte/framework-integration-shared`
export const isFunction = (x) => typeof x === 'function';
const isEventProp = (name) => {
    const what = name.startsWith('on') /*  && name !== 'onEditorChange' */;
    console.log('isEventProp', name, what);
    return what;
};
const eventAttrToEventName = (attrName) => attrName.substring(2);
export const configHandlers2 = (handlerLookup, on, off, adapter, prevProps, props, boundHandlers) => {
    const prevEventKeys = Object.keys(prevProps).filter(isEventProp);
    const currEventKeys = Object.keys(props).filter(isEventProp);
    const removedKeys = prevEventKeys.filter((key) => props[key] === undefined);
    const addedKeys = currEventKeys.filter((key) => prevProps[key] === undefined);
    removedKeys.forEach((key) => {
        // remove event handler
        const eventName = eventAttrToEventName(key);
        const wrappedHandler = boundHandlers[eventName];
        off(eventName, wrappedHandler);
        delete boundHandlers[eventName];
    });
    addedKeys.forEach((key) => {
        const wrappedHandler = adapter(handlerLookup, key);
        const eventName = eventAttrToEventName(key);
        boundHandlers[eventName] = wrappedHandler;
        on(eventName, wrappedHandler);
    });
};
export const configHandlers = (editor, prevProps, props, boundHandlers, lookup) => configHandlers2(lookup, editor.on.bind(editor), editor.off.bind(editor), 
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
(handlerLookup, key) => (e) => { var _a; return (_a = handlerLookup(key)) === null || _a === void 0 ? void 0 : _a(e, editor); }, prevProps, props, boundHandlers);
export const isTextareaOrInput = (element) => element !== null && (element.tagName.toLowerCase() === 'textarea' || element.tagName.toLowerCase() === 'input');
const normalizePluginArray = (plugins) => {
    if (typeof plugins === 'undefined' || plugins === '') {
        return [];
    }
    return Array.isArray(plugins) ? plugins : plugins.split(' ');
};
// eslint-disable-next-line max-len
export const mergePlugins = (initPlugins, inputPlugins) => normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins));
export const isBeforeInputEventAvailable = () => window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function';
export const setMode = (editor, mode) => {
    if (editor !== undefined) {
        editor.mode.set(mode);
    }
};
